import { render, staticRenderFns } from "./ApplyForReturn.vue?vue&type=template&id=756d3354&scoped=true"
import script from "./ApplyForReturn.vue?vue&type=script&lang=js"
export * from "./ApplyForReturn.vue?vue&type=script&lang=js"
import style0 from "./ApplyForReturn.vue?vue&type=style&index=0&id=756d3354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756d3354",
  null
  
)

export default component.exports